import { convertDateToUTC } from './convert-date-to-utc'
import { FORMAT_LOCALE } from './locale'

export const formatDateLong = (value: string | Date) =>
  new Intl.DateTimeFormat(FORMAT_LOCALE, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(convertDateToUTC(new Date(value)))
